/**
 * Form(stack) component.
 *
 * @param {HTMLElement} formElement
 */
export function Form(formElement) {
  const radioButtons = formElement.querySelectorAll('input[type="radio"]');

  const onRadioClick = (e) => {
    const input = e.target;
    const checkedRadioButtons = formElement.querySelectorAll('.fsOptionLabel.checked');

    checkedRadioButtons.forEach((checkedRadioButton) => {
      checkedRadioButton.classList.remove('checked');
    });

    if (input.checked === true) {
      input.closest('label').classList.add('checked');
    }
  };

  /**
   * Initialize our component.
   */
  const init = () => {
    const siteUrlField = formElement.querySelector('#field157370400');
    if (siteUrlField) siteUrlField.value = window.location.host;

    radioButtons.forEach((radioButton) => {
      radioButton.addEventListener('click', onRadioClick);
    });
  };

  init();
}
